import { render, staticRenderFns } from "./PictosTray.vue?vue&type=template&id=202d27b6&"
import script from "./PictosTray.vue?vue&type=script&lang=js&"
export * from "./PictosTray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports